import React from 'react';
import errorBoundary from '@ifeng-fe/errorBoundary';
import style from './index.css';
import PropTypes from 'prop-types';

const Divider = ({ endTime }) => {
    return (
        endTime && (
            <div className={style.divider}>
                <div className={style.leftline} />
                <div className={style.dividertext}>{endTime}</div>
                <div className={style.rightline} />
            </div>
        )
    );
};

Divider.propTypes = {
    endTime: PropTypes.string,
};

export default errorBoundary(Divider);
